import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function LinkRedirect() {
  const { linkId } = useParams();
  const nav = useNavigate();
  useEffect(() => {
    api.post(`/payment-links/${linkId}/checkout`)
      .then(({ data }) => nav(data.pay_url, { replace: true }))
      .catch(() => { toast.error("Ödeme linki geçersiz veya pasif."); nav("/", { replace: true }); });
  }, [linkId, nav]);
  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="text-center">
        <Loader2 className="mx-auto animate-spin text-primary" size={32} />
        <p className="mt-3 text-sm text-muted-foreground">Ödeme sayfası hazırlanıyor...</p>
      </div>
    </div>
  );
}
